// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"53":"4262d67d","640":"a436d765"}[chunkId] + ".js";
};